export type Speaker = "you" | "astrologer";

export interface TranscriptLine {
  readonly id: string;
  readonly speaker: Speaker;
  readonly text: string;
  readonly isFinal: boolean;
}

const MINUTE_WORDS = ["", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine"];

/** "Under a minute", "Three minutes", "12 minutes". */
export function durationLabel(seconds: number): string {
  const minutes = Math.round(seconds / 60);
  if (minutes < 1) return "Under a minute";
  const word = MINUTE_WORDS[minutes];
  return word ? `${word} minute${minutes === 1 ? "" : "s"}` : `${minutes} minutes`;
}

function finals(lines: readonly TranscriptLine[], speaker: Speaker): readonly TranscriptLine[] {
  return lines.filter((l) => l.isFinal && l.speaker === speaker && l.text.trim());
}

/** The first thing the person said, which is what the call was about. */
export function questionOf(lines: readonly TranscriptLine[]): string | null {
  return finals(lines, "you")[0]?.text.trim() ?? null;
}

/** The last thing she said. */
export function closingOf(lines: readonly TranscriptLine[]): string | null {
  const said = finals(lines, "astrologer");
  return said.at(-1)?.text.trim() ?? null;
}

/**
 * Applies one transcription segment: a segment with a known id replaces its
 * earlier interim version; a new one is appended. Returns a new array.
 */
export function upsertLine(lines: readonly TranscriptLine[], line: TranscriptLine): readonly TranscriptLine[] {
  const index = lines.findIndex((l) => l.id === line.id);
  if (index < 0) return [...lines, line];
  return [...lines.slice(0, index), line, ...lines.slice(index + 1)];
}
